import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, DATE, NUM, formatErr } from "@/lib/api";
import DataTable, { EmptyState } from "@/components/app/DataTable";
import { canEditProduction, useAuth } from "@/lib/auth";

const STATUS_TONE = {
  draft: "bg-slate-100 text-slate-700",
  review: "bg-cyan-50 text-cyan-700 border border-cyan-200",
  approved: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  posted: "bg-blue-50 text-blue-700 border border-blue-200",
  locked: "bg-slate-200 text-slate-700",
};
const STATUS_LABEL = { draft: "Draft", review: "Review", approved: "Disetujui", posted: "Diposting", locked: "Dikunci" };

export default function Batches() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [products, setProducts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => { (async () => {
    setLoading(true);
    try {
      const [{ data: bs }, { data: prods }] = await Promise.all([api.get("/batches"), api.get("/products")]);
      setRows(bs); setProducts(Object.fromEntries(prods.map((p) => [p.id, p])));
    } catch (e) { toast.error(formatErr(e)); }
    finally { setLoading(false); }
  })(); }, []);

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between flex-wrap gap-4">
        <div>
          <span className="gc-label">Produksi</span>
          <h1 className="gc-h1 mt-1">Batch Produksi</h1>
          <p className="mt-2 text-slate-500 max-w-2xl">Rekam realisasi produksi termasuk penggunaan bahan, tenaga kerja, mesin, overhead, dan biaya lingkungan.</p>
        </div>
        {canEditProduction(user) && <Link to="/app/batches/new" className="gc-btn-primary" data-testid="btn-new-batch"><Plus className="w-4 h-4" /> Batch Baru</Link>}
      </div>
      {loading ? <div className="gc-card"><Loader2 className="w-4 h-4 animate-spin" /></div> : (
        <DataTable
          rows={rows}
          columns={[
            { key: "batch_no", header: "No. Batch", render: (r) => <Link to={`/app/batches/${r.id}`} className="font-semibold text-emerald-700 hover:underline">{r.batch_no}</Link> },
            { key: "product", header: "Produk", render: (r) => products[r.product_id]?.name || "-" },
            { key: "batch_date", header: "Tanggal", render: (r) => DATE(r.batch_date) },
            { key: "target_qty", header: "Target", align: "right", render: (r) => NUM(r.target_qty, 0) },
            { key: "good_qty", header: "Baik", align: "right", render: (r) => NUM(r.good_qty, 0) },
            { key: "reject_qty", header: "Gagal", align: "right", render: (r) => NUM(r.reject_qty, 0) },
            { key: "status", header: "Status", render: (r) => <span className={`gc-badge ${STATUS_TONE[r.status]}`}>{STATUS_LABEL[r.status] || r.status}</span> },
          ]}
          empty={<EmptyState title="Belum ada batch" desc="Mulai dari halaman Mix Design lalu buat batch berdasarkan formula." action={canEditProduction(user) && <Link to="/app/batches/new" className="gc-btn-primary"><Plus className="w-4 h-4" /> Batch Baru</Link>} />}
        />
      )}
    </div>
  );
}
